import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import routes from './routes'
import Cookies from 'js-cookie';
// 在应用启动时检查并重定向URL
/* if (typeof window !== 'undefined') {
    const url = new URL(window.location.href)
    const hasQuery = url.search && url.search.length > 1
    const hasHash = url.hash && url.hash.length > 1

    if (hasQuery && !hasHash) {
        const queryString = url.search
        window.location.replace(`${url.origin}${url.pathname}#/${queryString}`)
    }
}
 */

let router = createRouter({
    routes,
    history: createWebHistory()
});


/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach(async (to, from, next) => {

    // 判断是否需要登录才可以进入
    // console.log(`=========== router ============= ${to.name}`)
    // console.log(`router`,to)
    // 判断是否需要登录才可以进入
    let some = to.matched.some(_ => _.meta.auth);
    if (some) {
        // 这里依据 token 判断是否登录，可视情况修改
        const token =  Cookies.get("token");
        if (token && token !== 'undefined') {
            let auth = to.meta.auth;
            if (Array.isArray(auth)) {
                try {
                    let jwtPayload = getJwtPayload(token);
                    if (!jwtPayload) {
                        next({name:from.name})
                        return
                    }
                    let access = jwtPayload.role;
                    if (!access || !access.length) {
                        next({name:from.name})
                        return
                    }
                    let find = (auth as Array<string>).find((it) => access.indexOf(it) > -1);
                    if (!find) {
                        next({name:from.name})
                        return
                    }
                }catch (e) {
                    next({name:from.name})
                    return
                }

            }
            next();
        } else {
            // 没有登录的时候跳转到登录界面
            // 携带上登陆成功之后需要跳转的页面完整路径
            next({
                name: 'Login',
                query: {
                    redirect: to.fullPath
                }
            });
        }
    } else {
        // 不需要身份校验 直接通过
        next();
    }
});

/*
router.afterEach(to => {
    if (Setting.showProgressBar) iView.LoadingBar.finish();
    // 多页控制 打开新的页面
    store.dispatch('admin/page/open', to);
    // 更改标题
    util.title({
        title: to.meta.title
    });
    // 返回页面顶端
    window.scrollTo(0, 0);
});
*/

function  getJwtPayload(token:string): Object {
    // 分割JWT的三个部分
    const parts = token.split('.');
    // 解码JWT的第二部分（负载部分）
    const payload = parts[1];
    // 将Base64编码的负载解码回正常字符串
    const decodedPayload = atob(payload);
    // 解析为JSON对象
    return JSON.parse(decodedPayload);
}


export default router